/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$('body').on('change', '#product-select-1', function() {
  var vals = $(this).val();
  $('.upsell_cart_form_1 .ad_to_cart_coll').attr("data-var_id", vals);
});

$('body').on('change', '#product-select-2', function() {
  var vals = $(this).val();
  $('.upsell_cart_form_2 .ad_to_cart_coll').attr("data-var_id", vals);
});


$('body').on('click', '.upsell_cart_form_1 .ad_to_cart_coll', function(e) {
  e.preventDefault();
  var ID = $(this).attr("data-var_id");
  addItemToCart( ID, 1);    // paste your id product number
  $('.cart_dr').trigger( "click" );
});

$('body').on('click', '.upsell_cart_form_2 .ad_to_cart_coll', function(e) {
  e.preventDefault();
  var ID = $(this).attr("data-var_id");
  addItemToCart( ID, 1);    // paste your id product number
  $('.cart_dr').trigger( "click" );
});

function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
    }   
    
  }); 
}

$('body').on('click', '.Drawer__Container .accordion', function(e) {
  e.preventDefault();
  $(this).toggleClass("active");
  $('.Drawer__Container .panel').toggleClass("active");
});
